/**
 * Add an ICE candidate to the connection.
 * @method addIceCandidate
 * @param  {RTCIceCandidate} candidate A native candidate object.
 * @return {Promise} Resolves when the candidate is successfully added.
 */
export default function addIceCandidate (candidate) {
  const { nativePeer, proxyPeer, id, log } = this
  log.info('Adding ICE candidate.')

  return new Promise((resolve, reject) => {
    if (proxyPeer.remoteDescription.type && proxyPeer.remoteDescription.sdp) {
      nativePeer
        .addIceCandidate(candidate)
        .then(resolve)
        .catch(reject)
    } else {
      log.info('Cannot set remote ICE candidate without a remote description.')
      // TODO: Better error.
      reject(new Error(`Peer ${id} cannot set remote ICE candidate without a remote description.`))
    }
  })
}
